document.addEventListener('DOMContentLoaded', () => {
	const body = document.body;
	const toggleButton = document.querySelectorAll('.offcanvas-toggler');
	const offCanvasAll = document.querySelectorAll('.offcanvas');

	toggleButton.forEach((button) => {
		const offCanvas = document.querySelector('[data-toggler="' + button.dataset.toggle + '"]');

		offCanvas.classList.remove('hidden');

		button.addEventListener('click', () => {
			toggleOffCanvas(offCanvas, toggleButton);
			button.classList.toggle('toggle-open');
			body.classList.toggle('offcanvas-open');
			if (offCanvas.dataset.overlay) {
				body.classList.toggle('offcanvas-overlay');
			}
			toggleOffCanvasTabbing();
		});
	});

	offCanvasAll.forEach((offCanvas) => {
		const subMenuParent = offCanvas.querySelectorAll('.menu-item-has-children');
		const dropdownIcons = offCanvas.querySelectorAll('.fa-chevron-down');

		dropdownIcons.forEach((icon) => icon.setAttribute('tabindex', '0'));

		subMenuParent.forEach((parent) => {
			if (!parent.querySelector('.fa-chevron-down')) {
				return;
			}
			parent.querySelector('.fa-chevron-down').addEventListener('click', (e) => {
				e.preventDefault();
				toggleMobileSubmenu(parent);
			});
			parent.querySelector('.fa-chevron-down').addEventListener('keyup', (e) => {
				if ('Enter' === e.key) {
					e.preventDefault();
					toggleMobileSubmenu(parent);
				}
			});
		});

		// Close submenu's on Esc
		document.addEventListener('keyup', (e) => {
			if ('Escape' === e.key && body.classList.contains('offcanvas-open')) {
				toggleOffCanvas(offCanvas, toggleButton);
				body.classList.remove('offcanvas-open');
				toggleOffCanvasTabbing();
			}
		});

		// Close submenu when focus out of last VISIBLE menu item
		let currFocus = document;
		document.addEventListener('keyup', (e) => {
			if ('Tab' === e.key) {
				const menuItems = offCanvas.querySelectorAll('.menu-item');
				const visibleItems = [];
				menuItems.forEach((item) => {
					if (item.checkVisibility()) {
						visibleItems.push(item);
					}
				});
				if (
					visibleItems.length &&
					currFocus === visibleItems[visibleItems.length - 1] &&
					currFocus !== e.target.closest('.menu-item')
				) {
					toggleOffCanvas(offCanvas, toggleButton);
					body.classList.remove('offcanvas-open');
					toggleOffCanvasTabbing();
				}
				currFocus = e.target.closest('.menu-item');
			}
		});
	});

	toggleOffCanvasTabbing();

	function toggleOffCanvasTabbing() {
		const links = document.querySelectorAll('.offcanvas button, .offcanvas a, .offcanvas .fa-chevron-down');
		links.forEach((link) => {
			if (!body.classList.contains('offcanvas-open')) {
				link.setAttribute('tabindex', '0');
			} else {
				link.setAttribute('tabindex', '0');
			}
		});
	}
});

function toggleMobileSubmenu(parent) {
	const subMenu = parent.querySelector('.sub-menu');
	subMenu.classList.toggle('hidden');
	parent.querySelector('.fa-chevron-down').classList.toggle('rotate-180');
}

function toggleOffCanvas(offCanvas, toggleButton) {
	const toggleClasses = ['translate-x-full', 'translate-x-0', 'pointer-events-none', 'pointer-events-auto'];
	toggleClasses.map((list) => offCanvas.classList.toggle(list));
	toggleButton.forEach((button) => {
		button.querySelectorAll('.open-button').forEach((el) => el.classList.toggle('!hidden'));
		button.querySelectorAll('.close-button').forEach((el) => el.classList.toggle('!hidden'));
	});
	document.body.classList.toggle('overflow-hidden');
}
